import React from "react";
import { set } from "dot-prop-immutable";
import { SimpleForm as Form, Input, InputNumber, Switch, Collapse } from '@whalecloud/fdx';
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';

const valueKey = 'data.formItemSettings';
const { Panel } = Collapse;

/**
 * @param  {Object} element 当前元素
 * @param  {Function} updateElement 修改属性后，调用此方法更新element
 */
const PopEditSettings = ({ element, updateElement }) => {
  const messages = getLocale();

  const { data: { formSettings = {}, formItemSettings = {} } = {} } = element;
  const { rules = [] } = formSettings;
  const {
    dataTextField = 'partyName',
    dataValueField = 'value',
    modalProps,
    inputProps,
  } = formItemSettings;

  const required = rules[0]?.required;
  const message = rules[0]?.message || messages['PAGEBUIDER_SETTINGS_REQUIRED_TABLE_TIPS'];
  const newRuleItem = {
    required,
    message
  };

  const perWidth = Math.round((modalProps?.width / document.body.clientWidth) * 100)
  const perHeight = Math.round(((modalProps?.bodyStyle?.height + 81.6) / document.body.clientHeight) * 100)

  const initialValues = {
    dataTextField,
    dataValueField,
    'inputProps.placeholder': inputProps?.placeholder,
    'modalProps.title': modalProps?.title,
    'modalProps.width': perWidth || 0,
    'modalProps.bodyStyle.height': perHeight || 0,
    'modalProps.render': modalProps.render || '/remote-components/participant-table.js',
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      let propName = `${valueKey}.${key}`;
      let value = obj[key];
      if (key === 'modalProps.width') {
        value = (value / 100) * document.body.clientWidth;
      }
      if (key === 'modalProps.bodyStyle.height') {
        value = (value / 100) * document.body.clientHeight - 81.6
      }
      if (['required', 'message'].includes(key)) {
        propName = 'data.formSettings.rules';
        newRuleItem[key] = obj[key];
        value = [newRuleItem];
      }
      const newElement = set(element, propName, value);
      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <React.Fragment>
      <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
        <Panel header={messages["PAGEBUIDER_SETTINGS"]} key="1">
          <CommonItemSettings allowClearHide placeholderHide defaultValueHide disabledHide requiredHide />
          <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_PLACE_HOLDER']} name="inputProps.placeholder">
              <Input placeholder={messages['PAGEBUIDER_SETTINGS_PLACEHOLDER_PLACEHOLDER']} />
            </Form.Item>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_DATATEXTFIELD']} name="dataTextField">
              <Input />
            </Form.Item>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_DATAVALUEFIELD']} name="dataValueField">
              <Input />
            </Form.Item>
            <Form.Item label={messages['PARTICIPANT_SETTINGS_PAGE_URL']} name="modalProps.render">
              <Input placeholder="" />
            </Form.Item>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_TITLE']} name="modalProps.title">
              <Input />
            </Form.Item>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_MODAL_WIDTH']} name="modalProps.width">
              <InputNumber
                defaultValue={100}
                min={0}
                max={100}
                formatter={value => `${value}%`}
                parser={value => value.replace('%', '')}
              />
            </Form.Item>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_MODAL_HEIGHT']} name="modalProps.bodyStyle.height">
              <InputNumber
                defaultValue={100}
                min={0}
                max={100}
                formatter={value => `${value}%`}
                parser={value => value.replace('%', '')}
              />
            </Form.Item>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_REQUIRED_ITEM']} name="required" valuePropName="checked">
              <Switch />
            </Form.Item>
            {rules[0]?.required && (
              <Form.Item label={messages['PAGEBUIDER_SETTINGS_MESSAGE']} name="message">
                <Input.TextArea />
              </Form.Item>
            )}
          </Form>
        </Panel>
      </Collapse>
    </React.Fragment>
  );
};

export default PopEditSettings;
